<template>
  <WCModal @dismiss="dismiss('Dismissed')">
    <WCModalHeader class="d-flex align-items-baseline justify-content-between border-primary">
      <h3>
        {{ $t('youHave') }} {{ cartItemsCount }} {{ $t('item') }}
        <span v-if="cartItemsCount > 1">{{ $t('s') }}</span> {{ $t('inYourCart') }}
      </h3>
      <button @click="dismiss('Order not cancelled')" class="btn btn-link">
        {{ $t('cancel') }}
      </button>
    </WCModalHeader>
    <WCModalBody>
      <p>
        {{ $t('wouldYouLikeToAdd') }}
      </p>
      <button class="btn btn-outline-primary btn-block" @click="close('addItemsToCart')">
        {{ $t('addItemsToOrder') }}
      </button>
      <button class="btn btn-outline-primary btn-block" @click="close('saveItemsForLater')">
        {{ $t('saveItemsForLater') }}
      </button>
    </WCModalBody>
    <WCModalFooter>
      <p>{{ $t('changeYourMind') }}</p>
      <button @click="close()" class="btn btn-link">{{ $t('cancelEditOrder') }}</button>
    </WCModalFooter>
  </WCModal>
</template>

<script>
import ModalMixin from '@/modules/modals/mixins/ModalMixin';
import WCModal from '@/modules/modals/components/WCModal/WCModal.vue';
import WCModalHeader from '@/modules/modals/components/WCModalHeader/WCModalHeader.vue';
import WCModalBody from '@/modules/modals/components/WCModalBody/WCModalBody.vue';
import WCModalFooter from '@/modules/modals/components/WCModalFooter/WCModalFooter.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'WCEditCartModal',
  mixins: [ModalMixin],
  components: { WCModal, WCModalHeader, WCModalBody, WCModalFooter },
  computed: {
    ...mapGetters({
      cartItemsCount: 'cart/getCartLineItemCount',
    }),
  },
  methods: {
    ...mapActions({ fetchSuggestions: 'browse/fetchSuggestions' }),
  },
};
</script>
